const ModalHelpers = {
	openClose: (event, updateState, state, initialState, resetErrors) => {
		if (event) {
			// console.log('event', event.currentTarget.classList);
			/* If the closing event has the class bx--modal -- they clicked on the overlay, we don't want to close */
			if (!event.currentTarget.classList.contains("bx--modal")) {
				updateState({ open: !state.open, ...initialState });
				resetErrors();
				// console.log('reset');
			}
			/* else ignore and move on */
		} else {
			/* opening event needs to change state to 'open' */
			updateState({ open: !state.open, ...initialState });
			resetErrors();
		}
	},

	openCloseNoData: (event, updateState, state) => {
		if (event) {
			/* If the closing event has the class bx--modal -- they clicked on the overlay, we don't want to close */
			if (!event.currentTarget.classList.contains("bx--modal")) {
				updateState({ open: !state.open });
			}
			/* else ignore and move on */
		} else {
			/* opening event needs to change state to 'open' */
			updateState({ open: !state.open });
		}
	},

	openCloseCLModal: (event, updateState, state, initialState, resetErrors) => {
		updateState({ open: !state.open, ...initialState });
		resetErrors();
	}
};

export default ModalHelpers;
